/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useToggle } from '@tonic-one/react-hooks';
import CSpinner from '../../../components/CSpinner';
import { useEffect, useRef, useState } from 'react';
import { Steps } from 'antd';
import { ProvisionOrgInfo, StepIcon } from '../ProvisionModal/share';
import { Trans, useTranslation } from 'react-i18next';
import { deleteCookie, getProvisionCookie } from '@Utils/common';
import { ProvisionApi } from '@Apis';
import { reportPendo } from '@Utils/setupPendo';
import ErrorAlert from '../../../components/Common/ErrorAlert';
import { MultiAppsAuthenticationInfoRes } from '@Types/provision';
import { App, Service } from '@Types/app';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';
import i18next from 'i18next';

enum TeamsStatus {
  NotProvision = 0,
  ProvisioningGrantStep1Done = 1,
  ProvisioningGrantStep2Done = 2,
}

const TeamsGraphReAuthModal = ({
  orgId,
  onClose,
  authAccount,
}: {
  orgId: string;
  authAccount: string;
  onClose: () => void;
}) => {
  const { t } = useTranslation('provision');
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);

  const [teamsStatus, setTeamsStatus] = useState<TeamsStatus>(
    TeamsStatus.NotProvision
  );

  //example:
  // [
  //   {
  //     app: 'exchangeInlineMailFlow',
  //     installAppUrl: null,
  //     authenticationUrl:
  //       'https://login.microsoftonline.com/common/oauth2/authorize?client_id=8af0038e-67da-438d-9424-ce0e1e5f6325&response_type=code&prompt=consent&resource=https://graph.microsoft.com&state=azuread_mail_flow_inline_ex_72251c12c07a15cdcea1993e218c9620&redirect_uri=https%3A%2F%2Fadmin-dev.tmcas.trendmicro.net%2Fprovision.html',
  //     appId: '8af0038e-67da-438d-9424-ce0e1e5f6325',
  //   },
  //   {
  //     app: 'exchangeInline',
  //     installAppUrl: null,
  //     authenticationUrl:
  //       'https://login.microsoftonline.com/common/oauth2/authorize?client_id=f362d789-5a05-4faa-9708-70933c56e3ab&response_type=code&prompt=consent&resource=https://graph.microsoft.com&state=azuread_mail_inline_graph_api_72251c12c07a15cdcea1993e218c9620&redirect_uri=https%3A%2F%2Fadmin-dev.tmcas.trendmicro.net%2Fprovision.html',
  //     appId: 'f362d789-5a05-4faa-9708-70933c56e3ab',
  //   },
  // ];
  const [authenticationInfo, setAuthenticationInfo] =
    useState<null | MultiAppsAuthenticationInfoRes>(null);

  useEffect(() => {
    if (
      teamsStatus === TeamsStatus.NotProvision ||
      teamsStatus === TeamsStatus.ProvisioningGrantStep1Done
    ) {
      ProvisionApi.apiGetMultiAppsReAuthAuthenticationInfos(
        Service.Teams,
        orgId
      ).then((res) => {
        setAuthenticationInfo(res.data);
      });
    }
  }, []);

  if (!authenticationInfo) {
    return <></>;
  }
  return (
    <>
      <Modal isOpen={true} isClosable onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t(`provision.reAuth.service.teams.title`)}</ModalHeader>

          {/*<ExchangeInlineLearnMore />*/}

          <ModalBody>
            <ProvisionOrgInfo orgId={orgId} />

            {errorMsg && (
              <ErrorAlert
                errorMsg={errorMsg}
                onClose={() => setErrorMsg(undefined)}
              />
            )}
            <GrantPermissionSteps
              {...{
                teamsStatus,
                setTeamsStatus,
                authenticationInfo,
                orgId,
                setErrorMsg,
                authAccount,
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Button minWidth="20x" onClick={onClose}>
              {t('common.button.close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TeamsGraphReAuthModal;

//eslint-disable-next-line @typescript-eslint/no-unused-vars
const GrantPermissionSteps = ({
  teamsStatus,
  setTeamsStatus,
  authenticationInfo,
  orgId,
  setErrorMsg,
  authAccount,
}: {
  teamsStatus: TeamsStatus;
  setTeamsStatus: (status: TeamsStatus) => void;
  authenticationInfo: MultiAppsAuthenticationInfoRes;
  orgId: string;
  setErrorMsg: (msg: string | undefined) => void;
  authAccount: string;
}) => {
  const { t } = useTranslation(['provision', 'common']);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const titleTextStyle = {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: '400',
    color: colorStyle.color.primary,
  };
  const [loading, toggleLoading] = useToggle(false);
  const timeRef = useRef<any>(null);

  const onFirstPermission = () => {
    const authUrl = authenticationInfo[0].authenticationUrl;
    if (!authUrl) {
      return;
    }
    setErrorMsg(undefined);
    reportPendo('ReAuth.GrantPermission.Click', {
      orgId,
      service: App.Teams,
    });
    toggleLoading(true);
    window.open(authUrl, '_blank');
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    timeRef.current = setInterval(async () => {
      const teamsProvisionInfo = getProvisionCookie(
        'provision_status_azuread_graph_teams'
      );
      if (teamsProvisionInfo) {
        clearInterval(timeRef.current);
        deleteCookie('provision_status_');
        //{"code": "123"}
        const { error, code } = JSON.parse(teamsProvisionInfo);
        if (error === undefined || error.length === 0) {
          try {
            const res = await ProvisionApi.apiSaveReAuthInfo(
              App.Teams,
              code,
              authAccount,
              orgId
            );
            if (res.data?.status === 'failure') {
              // failure data = {
              //     "status": "failure",
              //     "reason": "FAILURE;451"  |  "PROVISION;CONFLICT"
              // }
              setErrorMsg(
                t([
                  `provision.service.teams.error.saveInfo.${res.data?.reason}`,
                  'common.apiException.internalError',
                ])
              );
            } else {
              setTeamsStatus(TeamsStatus.ProvisioningGrantStep1Done);
            }
          } catch {
            setErrorMsg(t('common.apiException.internalError'));
          }
        } else {
          setErrorMsg(t('provision.service.teams.error.deniedGrant'));
        }
        toggleLoading(false);
      }
    }, 1000);
  };
  const onSecondPermission = () => {
    const authUrl = authenticationInfo[1].authenticationUrl;
    if (!authUrl) {
      return;
    }
    setErrorMsg(undefined);
    reportPendo('ReAuth.GrantPermission.Click', {
      orgId,
      service: App.TeamsBasic,
    });
    toggleLoading(true);
    window.open(authUrl, '_blank');
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    timeRef.current = setInterval(async () => {
      const teamsBasicProvisionInfo = getProvisionCookie(
        'provision_status_azuread_graph_basic_teams'
      );
      if (teamsBasicProvisionInfo) {
        clearInterval(timeRef.current);
        deleteCookie('provision_status_');
        const { error, code } = JSON.parse(teamsBasicProvisionInfo);
        if (error === undefined || error.length === 0) {
          try {
            const res = await ProvisionApi.apiSaveReAuthInfo(
              App.TeamsBasic,
              code,
              authAccount,
              orgId
            );
            if (res.data?.status === 'failure') {
              // failure data = {
              //         "status": "failure",
              //         "reason": "FAILURE;451"
              //     }
              setErrorMsg(
                t([
                  `provision.service.teams.error.saveInfo.${res.data?.reason}`,
                  'common.apiException.internalError',
                ])
              );
            } else {
              setTeamsStatus(TeamsStatus.ProvisioningGrantStep2Done);
            }
          } catch {
            setErrorMsg(t('common.apiException.internalError'));
          }
        } else {
          setErrorMsg(t('provision.service.teams.error.deniedGrant'));
        }
        toggleLoading(false);
      }
    }, 1000);
  };

  useEffect(() => {
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    return () => {
      if (timeRef.current) {
        clearInterval(timeRef.current);
      }
    };
  }, []);

  return (
    <>
      {loading && <CSpinner />}
      <Steps
        direction="vertical"
        current={teamsStatus - 1}
        items={[
          {
            title: (
              <Text {...titleTextStyle}>
                <Trans
                  i18nKey="provision.reAuth.service.teams.details.userConfiguration.STEP1"
                  ns="provision"
                >
                  placeholder
                  <Link
                    href={getCasOLHLink(
                      CAS_DOC_LINK.provision.teams.userConfiguration,
                      i18next.language
                    )}
                    target="_blank"
                  >
                    placeholder
                  </Link>
                  placeholder
                </Trans>
              </Text>
            ),
            description: (
              <Flex direction="column" pt="16px" gap="16px">
                <Box>
                  {teamsStatus < TeamsStatus.ProvisioningGrantStep1Done ? (
                    <Button
                      variant="secondary"
                      borderRadius="2rem"
                      onClick={() => {
                        onFirstPermission();
                      }}
                    >
                      {t('provision.button.grantPermission')}
                    </Button>
                  ) : (
                    <Text color={colorStyle.color.tertiary}>
                      {t('provision.common.permissionGranted')}
                    </Text>
                  )}{' '}
                </Box>
              </Flex>
            ),
            icon: (
              <StepIcon
                checked={teamsStatus >= TeamsStatus.ProvisioningGrantStep1Done}
              />
            ),
          },
          {
            title: (
              <Text color={colorStyle.color.primary}>
                {t(
                  'provision.reAuth.service.teams.details.userConfiguration.STEP2'
                )}
              </Text>
            ),
            description: (
              <Flex direction="column" pt="16px" gap="16px">
                <Box>
                  {teamsStatus < TeamsStatus.ProvisioningGrantStep2Done ? (
                    <Button
                      variant="secondary"
                      borderRadius="2rem"
                      disabled={
                        !(
                          teamsStatus === TeamsStatus.ProvisioningGrantStep1Done
                        )
                      }
                      onClick={() => {
                        onSecondPermission();
                      }}
                    >
                      {t('provision.button.grantPermission')}
                    </Button>
                  ) : (
                    <Text color={colorStyle.color.tertiary}>
                      {t('provision.common.permissionGranted')}
                    </Text>
                  )}
                </Box>
              </Flex>
            ),
            icon: (
              <StepIcon
                checked={teamsStatus >= TeamsStatus.ProvisioningGrantStep2Done}
              />
            ),
          },
        ]}
      />
    </>
  );
};
